module.exports = __webpack_public_path__ + "img/9.b424bd09.png";